import React from "react";
import './WaitSelectNumber.css';

const WaitSelectNumber = () => {
    return(
        <div className = "pulsatingText">
            <h1 style = {{fontSize: "25px", color: "#C0C0C0"}}>Select your number!</h1>
        </div>
    );
}

export default WaitSelectNumber;